import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import {
  fetchTotalContactListCount, fetchTotalInternationalListCount, fetchTotalCallbackListCount,
  fetchTotalAppointmentEnquiryCount, fetchTotalJobApplicationCount
} from "../../Adapters/ApiAdapter";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { tokens } from "../../theme";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import EmailIcon from "@mui/icons-material/Email";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import WorkIcon from '@mui/icons-material/Work';
// import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import Header from "../../components/Header";
import StatBox from "../../components/StatBox";
import { getUserDetails } from "../../utils/auth";

const Dashboard = () => {
  const user = getUserDetails();
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.up("sm"));
  const colors = tokens(theme.palette.mode);

  const [counts, setCounts] = useState({
    contacts: 0,
    internationals: 0,
    appointments: 0,
    callbacks: 0,
    jobs: 0,
  });

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [
          contactRes,
          internationalRes,
          appointmentRes,
          callbackRes,
          jobRes,
        ] = await Promise.all([
          fetchTotalContactListCount(),
          fetchTotalInternationalListCount(),
          fetchTotalAppointmentEnquiryCount(),
          fetchTotalCallbackListCount(),
          fetchTotalJobApplicationCount(), // optional – returns 0 if the API isn\'t enabled yet
        ]);

        setCounts({
          contacts: contactRes?.count || 0,
          internationals: internationalRes?.count || 0,
          appointments: appointmentRes?.count || 0,
          callbacks: callbackRes?.count || 0,
          jobs: jobRes?.count || 0,
        });
      } catch (err) {
        console.error(err);
        toast.error("Failed to load dashboard statistics – please refresh");
      }
    };

    fetchCounts();
  }, []);


  return (
    <Box m="20px">
      {/* HEADER */}

      <Box
        display={smScreen ? "flex" : "block"}
        flexDirection={smScreen ? "row" : "column"}
        justifyContent={smScreen ? "space-between" : "start"}
        alignItems={smScreen ? "center" : "start"}
        m="10px 0"
      >
        <Header title="DASHBOARD" subtitle="Welcome to your dashboard" />

        <Box>
          <Button
            sx={{
              backgroundColor: colors.blueAccent[700],
              color: colors.grey[100],
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
            }}
          >
            <DownloadOutlinedIcon sx={{ mr: "10px" }} />
            Download Reports
          </Button>
        </Box>
      </Box>

      {/* GRID & CHARTS */}
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid xs={12} sm={12} md={6} lg={3} xl={3}>
          <Box
            width="100%"
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <StatBox
              title={`${counts.contacts}`}
              subtitle="Contact Form Leads Receieved"
              // progress="0.75"
              // increase="+14%"
              icon={
                <EmailIcon
                  sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                />
              }
            />
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={3} xl={3}>
          <Box
            width="100%"
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <StatBox
              title={`${counts.internationals}`}
              subtitle="International Page Form Leads"
              // progress="0.50"
              // increase="+21%"
              icon={<FlightTakeoffIcon sx={{ color: colors.greenAccent[600], fontSize: 26 }} />}
            />
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={3} xl={3}>
          <Box
            width="100%"
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <StatBox
              title={`${counts.appointments}`}
              subtitle="Doctors Appointment Form Leads"
              // progress="0.30"
              // increase="+5%"
              icon={<EventAvailableIcon sx={{ color: colors.greenAccent[600], fontSize: 26 }} />}
            />
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={3} xl={3}>
          <Box
            width="100%"
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <StatBox
              title={`${counts.jobs}`}
              subtitle="Job Applications Form Leads"
              // progress="0.80"
              // increase="+43%"
              icon={<WorkIcon sx={{ color: colors.greenAccent[600], fontSize: 26 }} />}
            />
          </Box>
        </Grid>

        {/* Optional – JOB APPLICATIONS (uncomment if you want the fifth stat box) */}
        {/*
        <Grid xs={12} sm={6} md={6} lg={3} xl={3}>
          <Box
            width="100%"
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <StatBox
              title={`${counts.callbacks}`}
              subtitle="Job Applications"
              progress="1"
              increase=""
              icon={<PhoneInTalkIcon sx={{ color: colors.greenAccent[600], fontSize: 26 }} />}
            />
          </Box>
        </Grid>
        */}

        <Grid
          xs={12}
          sm={12}
          md={8}
          lg={8}
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
